import React from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import { SimpleForm as Form, Collapse, Select } from '@whalecloud/fdx';


const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';

const HyperlinkSettings = ({ element, updateElement }) => {
  const messages = getLocale();
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    text,
    fontSize,
    href,
  } = formItemSettings;

  const initialValues = {
    text,
    fontSize,
    href,
  };

  const fontSizeList = [11, 12, 13, 14, 18, 24, 36, 48, 64, 72, 96, 144, 288];

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <React.Fragment>
      <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
        <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
          <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
            <Form.Item label={messages.PAGEBUIDER_SETTINGS_TEXT} name="text">
              <CustomInput />
            </Form.Item>
            <Form.Item label={messages.PAGEBUIDER_SETTINGS_URL} name="url">
              <CustomInput />
            </Form.Item>
            <Form.Item label={messages.PAGEBUIDER_FONT_SIZE} name="fontSize">
              <Select>
                {fontSizeList.map(item => (<Option value={item} key={`font-size-${item}`}>{item}</Option>))}
              </Select>
            </Form.Item>
          </Form>
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};

export default HyperlinkSettings;
